import { create } from 'zustand'

/**
 * The one piece of UI state the counting shell and the capture screen have to agree on.
 *
 * The session menu is a drawer rendered by `CountMobileLayout`, while the scanner and its
 * `paused` flag live in `CountCapturePage` below it — neither owns the other, so the flag cannot
 * simply be a prop. Without it detection keeps running behind the open menu, and a stray scan
 * beeps and opens the quantity sheet underneath, stacking two drawers.
 *
 * Deliberately NOT persisted (unlike the restaurant selection): a menu that was open when the
 * tab died must not come back open on the next load.
 */
interface CountUiState {
  sessionMenuOpen: boolean
  setSessionMenuOpen: (open: boolean) => void
}

export const useCountUiStore = create<CountUiState>()((set) => ({
  sessionMenuOpen: false,
  setSessionMenuOpen: (open) => set({ sessionMenuOpen: open }),
}))
